import React from 'react';
import { defineMessages } from 'react-intl';
import { LoadingOutlined, SaveOutlined,StopOutlined } from '@ant-design/icons';
import useTranslate from '@hooks/useTranslate';
import { Col, Flex, Row } from 'antd';
import classNames from 'classnames';

import styles from './FooterModal.module.scss';
const messages = defineMessages({
    objectName: 'Menu group',
    updateSuccess: 'Update Successfully',
    createSuccess: 'Create Successfully',
    updateDescription: 'Menu group update successfully',
    createDescription: 'Menu group added successfully',
    cancel: 'Cancel',
    update: 'Update',
    createNew: 'Add to category',
    create: 'Create',
    archive: 'Delete',
    delete: 'Delete',
    save: 'Save',
});
const FooterModal = ({
    handleCancel,
    isEditing,
    form,
    onDelete,
    label,
    create,
    isCustomPage,
    handleSave,
    disableSave,
    disableDelete,
    hideSave = false,
    loading,
}) => {
    const translate = useTranslate();
    return (
        <Row>
            <Col span={24} style={{ marginTop: '4px' }}>
                <div className={styles.footer}>
                    <Flex>
                        <div
                            className={styles.buttonLeft}
                            onClick={() => {
                                handleCancel();
                            }}
                        >
                            <StopOutlined style={{ color: 'red', marginRight: '6px' }} />
                            {translate.formatMessage(messages.cancel)}
                        </div>
                    </Flex>
                    {!hideSave && (
                        <div
                            onClick={!disableSave && handleSave}
                            className={classNames(styles.buttonRight, disableSave && styles.disableSave)}
                        >
                            {loading && <LoadingOutlined style={{ marginRight: '3px' }} />}
                            <SaveOutlined style={{ marginRight: '6px' }} />
                            {label
                                ? label
                                : isEditing
                                    ? translate.formatMessage(messages.save)
                                    : translate.formatMessage(messages.create)}
                        </div>
                    )}
                </div>
            </Col>
        </Row>
    );
};

export default FooterModal;
